export default "__VITE_ASSET__DBY2$pLZ__"